import React from "react";
import { makeStyles, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import Moment from "react-moment";
import "moment/locale/ko";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({}));

interface NoticeProps {
  title: string;
  date: string;
  idNum: number;
}

function Schedule({ title, date, idNum }: NoticeProps) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Grid
      xs={12}
      item
      container
      component={"li"}
      className={"notice-list"}
      style={{ paddingTop: 4, paddingBottom: 4 }}
    >
      <Grid
        xs={!matches ? 9 : 8}
        item
        container
        style={{
          fontWeight: 500,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          wordWrap: "normal",
          width: "100%",
          overflow: "hidden",
          paddingRight: 16,
          fontFamily: "Noto Sans KR",
        }}
      >
        {title}
      </Grid>
      <Grid
        xs={!matches ? 3 : 4}
        item
        style={{ color: "rgba(0, 0, 0, 0.6)", textAlign: "right" }}
      >
        <Moment
          locale="ko"
          format={`${!matches ? "YYYY년 MMM Do" : "YY년 MMM Do"}`}
        >
          {date}
        </Moment>
      </Grid>
    </Grid>
  );
}

// export default MainContainer;
export default Schedule;
